/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 01/02/2022 09:07
 */

import {ModelProperty} from '../../engine/model-property';
import {NameValue} from '../../tool/name-value';
import {Filter} from '../../tool/filter';
import {ColumnManager} from '../../manager/table-manager/column-manager';
import {GroupEntity} from '../../tool/group-entity';
import {IEntity} from '../../interface/IEntity';

export class DataTableState<T extends IEntity> {
  public groupProperty: ColumnManager = null;
  public filterProperties: Filter[] = [];
  public groupProperties: GroupEntity<T>[];

  /**
   * Add or update a column filter
   * @param property of column
   * @param filters list of filters
   */
  public setFilter(property: ModelProperty, filters: NameValue[]) {
    const filter = this.filterProperties.find((f) => {
      return f.property.id === property.id;
    });
    if (filter) {
      filter.filters = filters;
    } else {
      this.filterProperties.push(new Filter(property, filters));
    }
  }

  /**
   * get Filters of property (if property hasn't filters, return empty array)
   * @param property
   */
  public getFilter(property: ModelProperty): NameValue[] {
    const filter = this.filterProperties.find((f) => {
      return f.property.id === property.id;
    });
    return filter ? filter.filters : [];
  }

  public hasFilter(property: ModelProperty): boolean {
    const filter = this.filterProperties.find((f) => {
      return f.property.id === property.id;
    });
    return filter && filter.filters.length > 0;
  }

  public isGrouped(property: ModelProperty): boolean {
    return this.groupProperty && property.id === this.groupProperty.property.id;
  }

  public clearFilters() {
    for (const filter of this.filterProperties) {
      filter.filters = [];
    }
  }
}
